import Enums from "../enums/enums";
import i18n from "../locales/i18n";
import { DecompressZlipData } from "./shareHelper";

function GetSettingNumberByHeaderTransactionType(_setting, haderTransactionType, financeType) {
  let settingNumber = null;
  if (_setting && _setting.length > 0) {
    settingNumber = _setting.find(
      (x) => x.headerTransactionType === haderTransactionType && x.financeType === financeType
    );
  }

  let year = "";
  let yyyy = new RegExp("yyyy");
  let yy = new RegExp("yy");
  let mm = new RegExp("MM");
  let dd = new RegExp("dd");

  if (settingNumber && yyyy.test(settingNumber.formatDate)) {
    year =
      settingNumber.yearType === Enums.YearType.Eng
        ? Enums.DropdownSettingYearType.Year_4_Eng
        : Enums.DropdownSettingYearType.Year_4_Thai;
  } else if (settingNumber && yy.test(settingNumber.formatDate)) {
    year =
      settingNumber.yearType === Enums.YearType.Eng
        ? Enums.DropdownSettingYearType.Year_2_Eng
        : Enums.DropdownSettingYearType.Year_2_Thai;
  } else {
    year = Enums.DropdownSettingYearType.Not_Show;
  }

  let settingNumberTemplate = {
    headerTransactionType: haderTransactionType,
    financeType: financeType,
    prefix: settingNumber ? settingNumber.indexString : "",
    specialCharacters: settingNumber ? settingNumber.symbol : "",
    year: year,
    month: settingNumber && mm.test(settingNumber.formatDate) ? 0 : 1,
    date: settingNumber && dd.test(settingNumber.formatDate) ? 0 : 1,
    numberDocumentSequences: settingNumber ? settingNumber.amountRunningNumber : 5,
    runningTaxInvoice: "",
    isTransactionNumberDefault: settingNumber ? settingNumber.isTransactionNumberDefault : true,
  };
  return settingNumberTemplate;
}
function GetSettingNumberQuotation(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.Quotation,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };

  return settingNumber;
}

function GetSettingNumberTmpDeliveryNote(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.TemporaryDeliveryNote,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: true,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: true,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: true,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: true,
    },
  };
  return settingNumber;
}

function GetSettingNumberInvoice(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.Invoice,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberInvoiceTaxInvoice(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.InvoiceSalesTaxReceipt,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberDeliveryNotee(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.DeliveryNote,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: true,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: true,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: true,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: true,
    },
  };
  return settingNumber;
}

function GetSettingNumberReceipt(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.Receipt,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberReceiptTaxInvoice(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.ReceiptSalesTaxReceipt,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberSaleTaxInvoice(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.TaxInvoice,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberCreditNote(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.CreditNote,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberCreditNoteTaxInvoiceReceipt(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.CreditNoteTaxReceipt,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberBillingNote(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.BillingNote,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}
function GetSettingNumberDepositPaymentReceipt(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.Deposit,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}
function GetSettingNumberPurchaseRequisition(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.PurchaseRequisition,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}
function GetSettingNumberGoodsReceipt(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.GoodsReceipt,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}
function GetSettingNumberinvoiceReceipt(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.InvoiceReceipt,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}
function GetSettingNumberDeposit(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.Deposit,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}
function GetSettingNumberDepositTaxInvoice(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.DepositTaxInvoice,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}
function GetSettingNumberDebitNote(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.DebitNote,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberDebitNoteTaxInvoice(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.DebitNoteTaxInvoice,
    Enums.FinanceType.InFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberPurchaseOrder(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.Quotation,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberPurchaseOrderAsset(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.PurchaseOrderAsset,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberPRequisition(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.PurchaseRequisitionHeader,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: true,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: true,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: true,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: true,
    },
  };
  return settingNumber;
}

function GetSettingNumberExpense(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.Invoice,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberReceiveCN(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.CreditNote,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberCreditNoteTaxInvoice(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.CreditNoteTaxReceipt,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberBillingNoteExpense(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.BillingNote,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };
  return settingNumber;
}

function GetSettingNumberFixedAsset(_setting) {
  let getSettingNumber = GetSettingNumberByHeaderTransactionType(
    _setting,
    Enums.HeaderTransactionType.FixAssetExpense,
    Enums.FinanceType.OutFlow
  );
  let settingNumber = {
    headerTransactionType: getSettingNumber.headerTransactionType,
    financeType: getSettingNumber.financeType,
    isTransactionNumberDefault: getSettingNumber.isTransactionNumberDefault,
    prefix: {
      value: getSettingNumber.prefix,
      validateError: false,
      hidden: false,
    },
    specialCharacters: {
      value: getSettingNumber.specialCharacters,
      validateError: false,
      hidden: false,
    },
    year: {
      value: { value: getSettingNumber.year },
      validateError: false,
      hidden: false,
    },
    month: {
      value: { value: getSettingNumber.month },
      validateError: false,
      hidden: false,
    },
    date: {
      value: { value: getSettingNumber.date },
      validateError: false,
      hidden: false,
    },
    numberDocumentSequences: {
      value: { value: getSettingNumber.numberDocumentSequences },
      validateError: false,
      hidden: false,
    },
  };

  return settingNumber;
}

function ConvertToSettingTransactionNumberModel(_settingNumber) {
  let formatDate = "";
  let yearType = Enums.YearType.Eng;

  switch (_settingNumber.year.value.value) {
    case Enums.DropdownSettingYearType.Year_4_Eng:
      formatDate = "yyyy";
      yearType = Enums.YearType.Eng;
      break;
    case Enums.DropdownSettingYearType.Year_4_Thai:
      formatDate = "yyyy";
      yearType = Enums.YearType.Thai;
      break;
    case Enums.DropdownSettingYearType.Year_2_Eng:
      formatDate = "yy";
      yearType = Enums.YearType.Eng;
      break;
    case Enums.DropdownSettingYearType.Year_2_Thai:
      formatDate = "yy";
      yearType = Enums.YearType.Thai;
      break;
  }

  switch (_settingNumber.month.value.value) {
    case 0:
      formatDate = formatDate + "MM";
      break;
  }

  switch (_settingNumber.date.value.value) {
    case 0:
      formatDate = formatDate + "dd";
      break;
  }

  let settingTransactionNumberModel = {
    headerTransactionType: _settingNumber.headerTransactionType,
    financeType: _settingNumber.financeType,
    indexString: _settingNumber.prefix.value,
    symbol: _settingNumber.specialCharacters.value,
    formatDate: formatDate,
    yearType: yearType,
    amountRunningNumber: _settingNumber.numberDocumentSequences.value.value,
  };

  return settingTransactionNumberModel;
}

function GetSettingRemarkTemplate(
  _settingList,
  transactionType,
  financeType,
  transactionItemType = Enums.TransactionItemType.None
) {
  let setting = null;
  if (_settingList && _settingList.length > 0) {
    setting = _settingList.find(
      (x) =>
        x.transactionType === transactionType &&
        x.financeType == financeType &&
        x.transactionItemType == transactionItemType
    );
  }

  let settingRemarkTemplate = {
    transactionType: transactionType,
    financeType: financeType,
    transactionItemType: transactionItemType,
    value: setting ? setting.remark : "",
    validateError: false,
  };

  return settingRemarkTemplate;
}

function GetSettingDueDate(
  _setting,
  transactionType,
  financeType,
  transactionItemType = Enums.TransactionItemType.None
) {
  let setting = null;

  if (_setting && _setting.length > 0) {
    setting = _setting.find(
      (x) =>
        x.transactionType == transactionType &&
        x.financeType == financeType &&
        x.transactionItemType == transactionItemType
    );
  }

  let settingDueDateTemplate = {
    transactionType: transactionType,
    financeType: financeType,
    transactionItemType: transactionItemType,
    settingDueDateType: {
      value: {
        value: setting ? setting.settingDueDateType : Enums.DueDateSettingType.DateDistanct,
      },
    },
    day: {
      value: setting ? setting.day : 7,
    },
  };

  return settingDueDateTemplate;
}
function GetSettingMerchantAddressListDefault() {
  let settingMerchantAddressList = {
    id: 0,
    name: {
      value: "",
      validateError: false,
    },
    building: {
      value: "",
      validateError: false,
    },
    roomNo: {
      value: "",
      validateError: false,
    },
    floorNo: {
      value: "",
      validateError: false,
    },
    no: {
      value: "",
      validateError: false,
    },
    homeGroup: {
      value: "",
      validateError: false,
    },
    homeNo: {
      value: "",
      validateError: false,
    },
    soi: {
      value: "",
      validateError: false,
    },
    road: {
      value: "",
      validateError: false,
    },
    district1: {
      value: "",
      validateError: false,
    },
    district2: {
      value: "",
      validateError: false,
    },
    province: {
      value: "",
      validateError: false,
    },
    country: {
      name: "",
      code: "",
    },
    postCode: {
      value: "",
      validateError: false,
    },
    addressName: {
      value: "",
      validateError: false,
    },
  };
  return settingMerchantAddressList;
}
function GetSettingUserRoleTemplate(_userDetail = null) {
  let settingUserRoleTemplate = {
    userRole: Enums.UserRightSetting.ViewOnly,
    partialRight: { value: Enums.PartialRightType.RevenueExpenseDraftOnly },
    basicRight: { value: Enums.BasicRightType.CanViewExport },
    viewRight: { value: Enums.ViewRightType.CanViewExport },
    partialRightReport: { value: Enums.PartialRightReportType.CanViewExport },
    isManageUser: false,
    isManageProduct: false,
    isUsePayroll: false,
    isUsePeakBoard: false,
    isSeeSelfDocuments: false,
    isViewReport: false,
    authorityRole: Enums.AuthorityRole.None,
    manageFinanceAndJournals: {
      FinanceAccess: { value: false },
      ChartofAccountAndGL: { value: false },
      DailyJournalsAccess: {
        value: false,
        DailyJournalsRightType: { name: i18n.t("Select_DailyJournals.All"), value: Enums.DailyJournalsRightType.All },
      },
    },
    isManageAsset: false,
    manageContact: {
      contactAccess: false,
      addContact: false,
      editContact: false,
      deleteContact: false,
      exportContact: false,
    },
  };
  if (_userDetail) {
    switch (_userDetail.merchantUserRoleType) {
      case Enums.UserRight.ViewOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.ViewOnly;
        settingUserRoleTemplate.viewRight.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.ViewRightType.CanViewExport
            : Enums.ViewRightType.ConNotViewExport;
        break;
      case Enums.UserRight.RevenueExpenseDraftOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.RevenueExpenseDraftOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.RevenueExpenseApproveOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.RevenueExpenseApproveOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.RevenueExpenseExceptQOandPOApproveOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.RevenueAll:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.RevenueAll;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.RevenueExceptQOAll:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.RevenueExceptQOAll;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.ExpenseAll:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.ExpenseAll;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.ExpenseExceptPOAll:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.ExpenseExceptPOAll;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.QuotationOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.QuotationOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.Standard:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Basic;
        settingUserRoleTemplate.basicRight.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.BasicRightType.CanViewExport
            : Enums.BasicRightType.ConNotViewExport;
        break;
      case Enums.UserRight.BasicAndAdmin:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Admin;
        break;
      case Enums.UserRight.CreateRevenueOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.CreateRevenueOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.CreateExpenseOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.CreateExpenseOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.PurchaseOrderOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.PurchaseOrderOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.RevenueDraftOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.RevenueDraftOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.ExpenseDraftOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.ExpenseDraftOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.RevenueApproveOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.RevenueApproveOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.ExpenseApproveOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.ExpenseApproveOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.QuotationDraftOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.QuotationDraftOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.QuotationApproveOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.QuotationApproveOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.PurchaseOrderDraftOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.PurchaseOrderDraftOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
      case Enums.UserRight.PurchaseOrderApproveOnly:
        settingUserRoleTemplate.userRole = Enums.UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = Enums.PartialRightType.PurchaseOrderApproveOnly;
        settingUserRoleTemplate.partialRightReport.value =
          _userDetail.userRoleModel.role2 == Enums.ViewExportType.CanViewExport
            ? Enums.PartialRightReportType.CanViewExport
            : Enums.PartialRightReportType.ConNotViewExport;
        break;
    }

    settingUserRoleTemplate.isManageUser = _userDetail.manageUser;
    settingUserRoleTemplate.isManageProduct = _userDetail.manageProduct;
    settingUserRoleTemplate.isUsePayroll = _userDetail.isUsePayroll;
    settingUserRoleTemplate.isUsePeakBoard = _userDetail.isUsePeakBoard;
    settingUserRoleTemplate.isSeeSelfDocuments = _userDetail.isSeeSelfDocuments;
    settingUserRoleTemplate.authorityRole = _userDetail.authorityRole;
    settingUserRoleTemplate.manageFinanceAndJournals = SetToManageFinanceAndJournals(_userDetail.userRoleModel.role6);
    settingUserRoleTemplate.isManageAsset = _userDetail.manageAsset;
    settingUserRoleTemplate.manageContact = ConvertToContactUserRoleType(_userDetail.userRoleModel.role12);
  }
  return settingUserRoleTemplate;
}
function SetToManageFinanceAndJournals(role6) {
  let manageFinanceAndJournals = {
    FinanceAccess: { value: false },
    ChartofAccountAndGL: { value: false },
    DailyJournalsAccess: {
      value: false,
      DailyJournalsRightType: { name: i18n.t("Select_DailyJournals.All"), value: Enums.DailyJournalsRightType.All },
    },
  };

  switch (role6) {
    case Enums.FinanceAndAccountRights.All:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = Enums.DailyJournalsRightType.All;
      break;
    case Enums.FinanceAndAccountRights.FinanceAccessOnly:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = false;
      break;
    case Enums.FinanceAndAccountRights.GLAndStatementOnly:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = false;
      break;
    case Enums.FinanceAndAccountRights.DailyJournalsAll:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = Enums.DailyJournalsRightType.All;
      break;
    case Enums.FinanceAndAccountRights.DailyJournalsDraftOnly:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value =
        Enums.DailyJournalsRightType.DraftOnly;
      break;
    case Enums.FinanceAndAccountRights.DailyJournalsApproveOnly:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value =
        Enums.DailyJournalsRightType.ApproveOnly;
      break;
    case Enums.FinanceAndAccountRights.DailyJournalsAllAndFinance:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = Enums.DailyJournalsRightType.All;
      break;
    case Enums.FinanceAndAccountRights.DailyJournalsDraftOnlyAndFinance:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value =
        Enums.DailyJournalsRightType.DraftOnly;
      break;
    case Enums.FinanceAndAccountRights.DailyJournalsApproveOnlyAndFinance:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value =
        Enums.DailyJournalsRightType.ApproveOnly;
      break;
    case Enums.FinanceAndAccountRights.DailyJournalsAllAndGL:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = Enums.DailyJournalsRightType.All;
      break;
    case Enums.FinanceAndAccountRights.DailyJournalsDraftOnlyAndGL:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value =
        Enums.DailyJournalsRightType.DraftOnly;
      break;
    case Enums.FinanceAndAccountRights.DailyJournalsApproveOnlyAndGL:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value =
        Enums.DailyJournalsRightType.ApproveOnly;
      break;
    case Enums.FinanceAndAccountRights.FinanceAccountAndDailyJournalsDraftOnly:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value =
        Enums.DailyJournalsRightType.DraftOnly;
      break;
    case Enums.FinanceAndAccountRights.FinanceAccountAndDailyJournalsApproveOnly:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value =
        Enums.DailyJournalsRightType.ApproveOnly;
      break;
    case Enums.FinanceAndAccountRights.FinanceAndGL:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = false;
      break;
  }
  return manageFinanceAndJournals;
}
function ConvertToUserRole6(manageFinanceAndJournals) {
  let role6 = 0;
  if (
    manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == Enums.DailyJournalsRightType.All
  ) {
    role6 = Enums.FinanceAndAccountRights.All;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    !manageFinanceAndJournals.DailyJournalsAccess.value
  ) {
    role6 = Enums.FinanceAndAccountRights.FinanceAccessOnly;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    !manageFinanceAndJournals.DailyJournalsAccess.value
  ) {
    role6 = Enums.FinanceAndAccountRights.GLAndStatementOnly;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == Enums.DailyJournalsRightType.All
  ) {
    role6 = Enums.FinanceAndAccountRights.DailyJournalsAll;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == Enums.DailyJournalsRightType.DraftOnly
  ) {
    role6 = Enums.FinanceAndAccountRights.DailyJournalsDraftOnly;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value ==
      Enums.DailyJournalsRightType.ApproveOnly
  ) {
    role6 = Enums.FinanceAndAccountRights.DailyJournalsApproveOnly;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == Enums.DailyJournalsRightType.All
  ) {
    role6 = Enums.FinanceAndAccountRights.DailyJournalsAllAndFinance;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == Enums.DailyJournalsRightType.DraftOnly
  ) {
    role6 = Enums.FinanceAndAccountRights.DailyJournalsDraftOnlyAndFinance;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value ==
      Enums.DailyJournalsRightType.ApproveOnly
  ) {
    role6 = Enums.FinanceAndAccountRights.DailyJournalsApproveOnlyAndFinance;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == Enums.DailyJournalsRightType.All
  ) {
    role6 = Enums.FinanceAndAccountRights.DailyJournalsAllAndGL;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == Enums.DailyJournalsRightType.DraftOnly
  ) {
    role6 = Enums.FinanceAndAccountRights.DailyJournalsDraftOnlyAndGL;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value ==
      Enums.DailyJournalsRightType.ApproveOnly
  ) {
    role6 = Enums.FinanceAndAccountRights.DailyJournalsApproveOnlyAndGL;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == Enums.DailyJournalsRightType.DraftOnly
  ) {
    role6 = Enums.FinanceAndAccountRights.FinanceAccountAndDailyJournalsDraftOnly;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value ==
      Enums.DailyJournalsRightType.ApproveOnly
  ) {
    role6 = Enums.FinanceAndAccountRights.FinanceAccountAndDailyJournalsApproveOnly;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    !manageFinanceAndJournals.DailyJournalsAccess.value
  ) {
    role6 = Enums.FinanceAndAccountRights.FinanceAndGL;
  }

  return role6;
}
function ConvertToUserRole12(manageContact) {
  let role12 = Enums.ContactUserRoleType.None;
  if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.All;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessAndAddContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.editContact &&
    !manageContact.addContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessAndEditContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.deleteContact &&
    !manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessAndDeleteContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.exportContact &&
    !manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.deleteContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessAndExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.editContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessAddAndEditContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.deleteContact &&
    !manageContact.editContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessAddAndDeleteContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.exportContact &&
    !manageContact.editContact &&
    !manageContact.deleteContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessAddAndExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    !manageContact.addContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessEditAndDeleteContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.editContact &&
    manageContact.exportContact &&
    !manageContact.addContact &&
    !manageContact.deleteContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessEditAndExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.addContact &&
    !manageContact.editContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessDeleteAndExportContact;
  } else if (
    manageContact.addContact &&
    manageContact.editContact &&
    !manageContact.contactAccess &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.AddAndEditContact;
  } else if (
    manageContact.addContact &&
    manageContact.deleteContact &&
    !manageContact.contactAccess &&
    !manageContact.editContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.AddAndDeleteContact;
  } else if (
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    !manageContact.contactAccess &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.AddEditAndDeleteContact;
  } else if (
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.exportContact &&
    !manageContact.contactAccess &&
    !manageContact.DeleteContact
  ) {
    role12 = Enums.ContactUserRoleType.AddEditAndExportContact;
  } else if (
    manageContact.addContact &&
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.contactAccess &&
    !manageContact.editContact
  ) {
    role12 = Enums.ContactUserRoleType.AddDeleteAndExportContact;
  } else if (
    manageContact.editContact &&
    manageContact.deleteContact &&
    !manageContact.addContact &&
    !manageContact.exportContact &&
    !manageContact.contactAccess
  ) {
    role12 = Enums.ContactUserRoleType.EditAndDeleteContact;
  } else if (
    manageContact.editContact &&
    manageContact.exportContact &&
    !manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.deleteContact
  ) {
    role12 = Enums.ContactUserRoleType.EditAndExportContact;
  } else if (
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.contactAccess
  ) {
    role12 = Enums.ContactUserRoleType.AddEditDeleteAndExportContact;
  } else if (
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.editContact
  ) {
    role12 = Enums.ContactUserRoleType.DeleteAndExportContact;
  } else if (
    manageContact.deleteContact &&
    manageContact.exportContact &&
    manageContact.editContact &&
    !manageContact.addContact &&
    !manageContact.contactAccess
  ) {
    role12 = Enums.ContactUserRoleType.DeleteExportAndEditContact;
  } else if (
    manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccess;
  } else if (
    manageContact.addContact &&
    !manageContact.contactAccess &&
    !manageContact.editContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.AddContact;
  } else if (
    manageContact.editContact &&
    !manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.EditContact;
  } else if (
    manageContact.deleteContact &&
    !manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.DeleteContact;
  } else if (
    manageContact.exportContact &&
    !manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.deleteContact
  ) {
    role12 = Enums.ContactUserRoleType.ExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessAddEditAndDeleteContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.exportContact &&
    !manageContact.deleteContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessAddEditAndExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.editContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessAddDeleteAndExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.addContact
  ) {
    role12 = Enums.ContactUserRoleType.ContactAccessEditDeleteAndExportContact;
  }
  return role12;
}
function ConvertToContactUserRoleType(role12) {
  let manageContact = {
    contactAccess: false,
    addContact: false,
    editContact: false,
    deleteContact: false,
    exportContact: false,
  };

  switch (role12) {
    case Enums.ContactUserRoleType.All:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.ContactAccessAndAddContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.ContactAccessAndEditContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.ContactAccessAndDeleteContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.ContactAccessAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.ContactAccessAddAndEditContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.ContactAccessAddAndDeleteContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.ContactAccessAddAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.ContactAccessEditAndDeleteContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.ContactAccessEditAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.ContactAccessDeleteAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.AddAndEditContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.AddAndDeleteContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.AddAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.AddEditAndDeleteContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.AddEditAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.AddDeleteAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.EditAndDeleteContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.EditAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.AddEditDeleteAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.DeleteAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.DeleteExportAndEditContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.ContactAccess:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.AddContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.EditContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.DeleteContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.ExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.ContactAccessAddEditAndDeleteContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case Enums.ContactUserRoleType.ContactAccessAddEditAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.ContactAccessAddDeleteAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case Enums.ContactUserRoleType.ContactAccessEditDeleteAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
  }
  return manageContact;
}

function ConverToUserRoleModel(_settingUesrRole) {
  let settingUserRole = {
    role1: 0,
    role2: 0,
    role3: 0,
    role4: 0,
    role5: _settingUesrRole.isManageUser ? 1 : 0,
    role6: ConvertToUserRole6(_settingUesrRole.manageFinanceAndJournals),
    role7: _settingUesrRole.isUsePayroll ? 1 : 0,
    role8: _settingUesrRole.isUsePeakBoard ? 1 : 0,
    role9: _settingUesrRole.isManageProduct ? 1 : 0,
    role10: _settingUesrRole.isSeeSelfDocuments ? 1 : 0,
    role11: _settingUesrRole.isManageAsset ? 1 : 0,
    role12: ConvertToUserRole12(_settingUesrRole.manageContact),
  };
  switch (_settingUesrRole.userRole) {
    case Enums.UserRightSetting.ViewOnly:
      switch (_settingUesrRole.viewRight.value) {
        case Enums.ViewRightType.CanViewExport:
          settingUserRole.role1 = 2;
          settingUserRole.role2 = 1;
          break;
        case Enums.ViewRightType.ConNotViewExport:
          settingUserRole.role1 = 2;
          break;
      }
      break;
    case Enums.UserRightSetting.Partial:
      switch (_settingUesrRole.partialRight.value) {
        case Enums.PartialRightType.RevenueExpenseDraftOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 3;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 3;
              break;
          }
          break;
        case Enums.PartialRightType.RevenueExpenseApproveOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 4;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 4;
              break;
          }
          break;
        case Enums.PartialRightType.RevenueAll:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 5;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 5;
              break;
          }
          break;
        case Enums.PartialRightType.ExpenseAll:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 6;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 6;
              break;
          }
          break;
        case Enums.PartialRightType.QuotationOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 7;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 7;
              break;
          }
          break;
        case Enums.PartialRightType.CreateRevenueOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 8;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 8;
              break;
          }
          break;
        case Enums.PartialRightType.CreateExpenseOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 9;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 9;
              break;
          }
          break;
        case Enums.PartialRightType.PurchaseOrderOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 10;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 10;
              break;
          }
          break;
        case Enums.PartialRightType.RevenueDraftOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 11;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 11;
              break;
          }
          break;
        case Enums.PartialRightType.ExpenseDraftOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 12;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 12;
              break;
          }
          break;
        case Enums.PartialRightType.RevenueApproveOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 13;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 13;
              break;
          }
          break;
        case Enums.PartialRightType.ExpenseApproveOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 14;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 14;
              break;
          }
          break;
        case Enums.PartialRightType.QuotationDraftOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 15;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 15;
              break;
          }
          break;
        case Enums.PartialRightType.QuotationApproveOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 16;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 16;
              break;
          }
          break;
        case Enums.PartialRightType.PurchaseOrderDraftOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 17;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 17;
              break;
          }
          break;
        case Enums.PartialRightType.PurchaseOrderApproveOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 18;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 18;
              break;
          }
          break;
        case Enums.PartialRightType.ExpenseExceptPOAll:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 19;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 19;
              break;
          }
          break;
        case Enums.PartialRightType.RevenueExceptQOAll:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 20;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 20;
              break;
          }
          break;
        case Enums.PartialRightType.RevenueExpenseExceptQOandPOApproveOnly:
          switch (_settingUesrRole.partialRightReport.value) {
            case Enums.PartialRightReportType.CanViewExport:
              settingUserRole.role1 = 21;
              settingUserRole.role2 = 1;
              break;
            case Enums.PartialRightReportType.ConNotViewExport:
              settingUserRole.role1 = 21;
              break;
          }
          break;
      }
      break;
    case Enums.UserRightSetting.Basic:
      switch (_settingUesrRole.basicRight.value) {
        case Enums.BasicRightType.CanViewExport:
          settingUserRole.role1 = 1;
          settingUserRole.role2 = 1;
          settingUserRole.role3 = 1;
          break;
        case Enums.BasicRightType.ConNotViewExport:
          settingUserRole.role1 = 1;
          settingUserRole.role3 = 1;
          break;
      }
      break;
    case Enums.UserRightSetting.Admin:
      settingUserRole.role1 = 1;
      settingUserRole.role2 = 1;
      settingUserRole.role3 = 1;
      settingUserRole.role4 = 1;
      break;
  }
  return settingUserRole;
}

function SetValidateError(_duplicateList, _settingNumberRevenue, _settingNumberExpense) {
  _duplicateList.forEach((item) => {
    switch (item.headerTransactionType) {
      case Enums.HeaderTransactionType.Quotation:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.quotation.prefix.validateError = true;
        } else {
          _settingNumberExpense.purchaseOrder.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.PurchaseOrderAsset:
        if (item.financeType == Enums.FinanceType.OutFlow) {
          _settingNumberExpense.purchaseOrderAsset.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.TemporaryDeliveryNote:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.tmpDeliveryNote.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.Invoice:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.invoice.prefix.validateError = true;
        } else {
          _settingNumberExpense.expense.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.InvoiceSalesTaxReceipt:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.invoiceTaxInvoice.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.DeliveryNote:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.deliveryNote.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.Receipt:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.receipt.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.ReceiptSalesTaxReceipt:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.receiptTaxInvoice.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.TaxInvoice:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.saleTaxInvoice.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.CreditNote:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.creditNote.prefix.validateError = true;
        } else {
          _settingNumberExpense.receiveCN.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.CreditNoteTaxReceipt:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.creditNoteTaxInvoiceReceipt.prefix.validateError = true;
        } else {
          _settingNumberExpense.creditNoteTaxInvoice.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.BillingNote:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.billingNote.prefix.validateError = true;
        } else {
          _settingNumberExpense.billingNoteExpense.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.DebitNote:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.debitNote.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.DebitNoteTaxInvoice:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.debitNoteTaxInvoice.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.PurchaseRequisitionHeader:
        if (item.financeType == Enums.FinanceType.OutFlow) {
          _settingNumberExpense.pRequisition.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.FixAssetExpense:
        if (item.financeType == Enums.FinanceType.OutFlow) {
          _settingNumberExpense.fixedAsset.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.Deposit:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.deposit.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.DebitNoteTaxInvoice:
        if (item.financeType == Enums.FinanceType.InFlow) {
          _settingNumberRevenue.depositTaxInvoice.prefix.validateError = true;
        }
        break;
      case Enums.HeaderTransactionType.Deposit:
        if (item.financeType == Enums.FinanceType.OutFlow) {
          _settingNumberExpense.deposit.prefix.validateError = true;
        }
        break;
    }
  });
}
function CheckErrorUpdateMerchantDtail(fields, isAlreadyError) {
  if (!isAlreadyError) {
    Object.values(fields).forEach((field) => {
      if (!isAlreadyError && field.validateError) {
        isAlreadyError = field.validateError;
      }
    });
  }
  return isAlreadyError;
}
export default {
  GetSettingNumberRevenue(_setting) {
    let settingNumberRevenue = {
      quotation: GetSettingNumberQuotation(_setting),
      tmpDeliveryNote: GetSettingNumberTmpDeliveryNote(_setting),
      invoice: GetSettingNumberInvoice(_setting),
      invoiceTaxInvoice: GetSettingNumberInvoiceTaxInvoice(_setting),
      deliveryNote: GetSettingNumberDeliveryNotee(_setting),
      receipt: GetSettingNumberReceipt(_setting),
      receiptTaxInvoice: GetSettingNumberReceiptTaxInvoice(_setting),
      saleTaxInvoice: GetSettingNumberSaleTaxInvoice(_setting),
      creditNote: GetSettingNumberCreditNote(_setting),
      creditNoteTaxInvoiceReceipt: GetSettingNumberCreditNoteTaxInvoiceReceipt(_setting),
      billingNote: GetSettingNumberBillingNote(_setting),
      debitNote: GetSettingNumberDebitNote(_setting),
      debitNoteTaxInvoice: GetSettingNumberDebitNoteTaxInvoice(_setting),
      deposit: GetSettingNumberDeposit(_setting),
      depositTaxInvoice: GetSettingNumberDepositTaxInvoice(_setting),
    };

    return settingNumberRevenue;
  },
  ConvertToContactUserRoleType(role12) {
    return ConvertToContactUserRoleType(role12);
  },
  SetToManageFinanceAndJournals(role6) {
    return SetToManageFinanceAndJournals(role6);
  },
  GetSettingNumberExpense(_setting) {
    let settingNumberExpense = {
      purchaseRequisition: GetSettingNumberPurchaseRequisition(_setting),
      purchaseOrder: GetSettingNumberPurchaseOrder(_setting),
      purchaseOrderAsset: GetSettingNumberPurchaseOrderAsset(_setting),
      pRequisition: GetSettingNumberPRequisition(_setting),
      expense: GetSettingNumberExpense(_setting),
      receiveCN: GetSettingNumberReceiveCN(_setting),
      creditNoteTaxInvoice: GetSettingNumberCreditNoteTaxInvoice(_setting),
      billingNoteExpense: GetSettingNumberBillingNoteExpense(_setting),
      fixedAsset: GetSettingNumberFixedAsset(_setting),
      deposit: GetSettingNumberDepositPaymentReceipt(_setting),
      goodsReceipt: GetSettingNumberGoodsReceipt(_setting),
      invoiceReceipt: GetSettingNumberinvoiceReceipt(_setting),
    };

    return settingNumberExpense;
  },
  ConvertToInputSettingMerchantDetail(
    _settingCompanyData,
    _settingCompanyContact,
    _settingCompanyAdditionalAddressList,
    _registeredAddressEng,
    _registeredAddress,
    _deliveryAddress,
    isUpdateOnboarding,
    addOnboarding
  ) {
    let registeredDate = new Date(_settingCompanyData.registeredDate);
    registeredDate = !isNaN(registeredDate.getTime()) ? registeredDate.ToDateJsonString() : null;
    let vatRegistrationDate = new Date(_settingCompanyData.vatRegistrationDate);
    vatRegistrationDate = !isNaN(vatRegistrationDate.getTime()) ? vatRegistrationDate.ToDateJsonString() : null;
    let settingMerchantDetail = {
      merchantTaxId: _settingCompanyData.merchantTaxId,
      merchantBranchCode: _settingCompanyData.merchantBranchCode,
      merchantName: _settingCompanyData.merchantName.value,
      merchantType: _settingCompanyData.merchantType,
      description: _settingCompanyData.description.value,
      registeredDate: registeredDate,
      vatRegistrationDate: vatRegistrationDate,
      isVat: _settingCompanyData.isVat,
      phone: _settingCompanyContact.phone.value,
      email: _settingCompanyContact.email.value,
      alternativeEmail: _settingCompanyContact.alternativeEmail.value,
      lineId: _settingCompanyContact.lineId.value,
      fax: _settingCompanyContact.fax.value,
      website: _settingCompanyContact.website.value,
      building: _registeredAddress.building.value,
      roomNo: _registeredAddress.roomNo.value,
      floorNo: _registeredAddress.floorNo.value,
      homeGroup: _registeredAddress.homeGroup.value,
      homeno: _registeredAddress.homeno.value,
      no: _registeredAddress.no.value,
      soi: _registeredAddress.soi.value,
      road: _registeredAddress.road.value,
      country: _registeredAddress.country.name == "ไทย" ? "Thailand" : _registeredAddress.country.name,
      district1: _registeredAddress.district1.value,
      district2: _registeredAddress.district2.value,
      province: _registeredAddress.province.value,
      postCode: _registeredAddress.postCode.value,
      sendBuilding: _deliveryAddress.building.value,
      sendRoomNo: _deliveryAddress.roomNo.value,
      sendFloorNo: _deliveryAddress.floorNo.value,
      sendHomeGroup: _deliveryAddress.homeGroup.value,
      sendHomeNo: _deliveryAddress.homeno.value,
      sendNo: _deliveryAddress.no.value,
      sendSoi: _deliveryAddress.soi.value,
      sendRoad: _deliveryAddress.road.value,
      sendCountry: _deliveryAddress.country.name == "ไทย" ? "Thailand" : _deliveryAddress.country.name,
      sendDistrict1: _deliveryAddress.district1.value,
      sendDistrict2: _deliveryAddress.district2.value,
      sendProvince: _deliveryAddress.province.value,
      sendPostCode: _deliveryAddress.postCode.value,
      addressList: [],
      isUpdateOnboarding: isUpdateOnboarding,
      addOnboarding: addOnboarding,
    };

    for (let settingCompanyAddress of _settingCompanyAdditionalAddressList) {
      settingMerchantDetail.addressList.push({
        id: settingCompanyAddress.id,
        name: settingCompanyAddress.name.value,
        building: settingCompanyAddress.building.value,
        roomNo: settingCompanyAddress.roomNo.value,
        floorNo: settingCompanyAddress.floorNo.value,
        no: settingCompanyAddress.no.value,
        homeGroup: settingCompanyAddress.homeGroup.value,
        homeNo: settingCompanyAddress.homeNo.value,
        soi: settingCompanyAddress.soi.value,
        road: settingCompanyAddress.road.value,
        district1: settingCompanyAddress.district1.value,
        district2: settingCompanyAddress.district2.value,
        province: settingCompanyAddress.province.value,
        country: settingCompanyAddress.country.name == "ไทย" ? "Thailand" : settingCompanyAddress.country.name,
        postCode: settingCompanyAddress.postCode.value,
        addressName: settingCompanyAddress.addressName.value,
        language: Enums.Language.None,
      });
    }
    settingMerchantDetail.addressList.push({
      id: _registeredAddressEng.id,
      name: _registeredAddressEng.name.value,
      building: _registeredAddressEng.building.value,
      roomNo: _registeredAddressEng.roomNo.value,
      floorNo: _registeredAddressEng.floorNo.value,
      no: _registeredAddressEng.no.value,
      homeGroup: _registeredAddressEng.homeGroup.value,
      homeNo: _registeredAddressEng.homeNo.value,
      soi: _registeredAddressEng.soi.value,
      road: _registeredAddressEng.road.value,
      district1: _registeredAddressEng.district1.value,
      district2: _registeredAddressEng.district2.value,
      province: _registeredAddressEng.province.value,
      country: _registeredAddressEng.country.name,
      postCode: _registeredAddressEng.postCode.value,
      addressName: _registeredAddressEng.addressName.value
        ? _registeredAddressEng.addressName.value
        : "Register Address EN",
      language: Enums.Language.English,
    });
    return settingMerchantDetail;
  },
  ConvertToInputSettingNumber(
    _settingisSeparateRunning,
    _settingNumberRevenue,
    _settingNumberExpense,
    _uniqueTransactionNumberType
  ) {
    let merchantSettingTransactionNumberModel = {
      isSeparateRunningInvoiceTaxInvoiceNumber: _settingisSeparateRunning.isSeparateRunningInvoiceTaxInvoiceNumber,
      isSeparateRunningReceiptTaxInvoiceNumber: _settingisSeparateRunning.isSeparateRunningReceiptTaxInvoiceNumber,
      isSeparateRunningCreditNoteTaxInvoiceNumber:
        _settingisSeparateRunning.isSeparateRunningCreditNoteTaxInvoiceNumber,
      isSeparateRunningDebitNoteTaxInvoiceNumber: _settingisSeparateRunning.isSeparateRunningDebitNoteTaxInvoiceNumber,
      isSeparateRunningPuchaseOrderAssetNumber: _settingisSeparateRunning.isSeparateRunningPuchaseOrderAssetNumber,
      isSeparateRunningDepositTaxInvoiceNumber: _settingisSeparateRunning.isSeparateRunningDepositTaxInvoiceNumber,
      uniqueTransactionNumberType: _uniqueTransactionNumberType,
      settingTransactionNumberList: [],
    };

    for (const [key, value] of Object.entries(_settingNumberRevenue)) {
      let settingTransactionNumberModel = ConvertToSettingTransactionNumberModel(value);
      merchantSettingTransactionNumberModel.settingTransactionNumberList.push(settingTransactionNumberModel);
    }

    for (const [key, value] of Object.entries(_settingNumberExpense)) {
      let settingTransactionNumberModel = ConvertToSettingTransactionNumberModel(value);
      merchantSettingTransactionNumberModel.settingTransactionNumberList.push(settingTransactionNumberModel);
    }

    return merchantSettingTransactionNumberModel;
  },
  GetSettingRemarkRevenue(_setting) {
    let settingRemarkRevenue = {
      quotation: GetSettingRemarkTemplate(_setting, Enums.TransactionType.Quotation, Enums.FinanceType.InFlow),
      invoice: GetSettingRemarkTemplate(_setting, Enums.TransactionType.Invoice, Enums.FinanceType.InFlow),
      receipt: GetSettingRemarkTemplate(_setting, Enums.TransactionType.Receipt, Enums.FinanceType.InFlow),
      salesTaxInvoice: GetSettingRemarkTemplate(_setting, Enums.TransactionType.TaxInvoice, Enums.FinanceType.InFlow),
      creditNote: GetSettingRemarkTemplate(_setting, Enums.TransactionType.CreditNote, Enums.FinanceType.InFlow),
      debitNote: GetSettingRemarkTemplate(_setting, Enums.TransactionType.BillingNote, Enums.FinanceType.InFlow),
      deposit: GetSettingRemarkTemplate(_setting, Enums.TransactionType.Deposit, Enums.FinanceType.InFlow),
    };
    return settingRemarkRevenue;
  },
  GetSettingRemarkExpense(_setting) {
    let settingRemarkExpense = {
      purchaseRequisition: GetSettingRemarkTemplate(
        _setting,
        Enums.TransactionType.PurchaseRequisition,
        Enums.FinanceType.OutFlow
      ),
      purchaseOrder: GetSettingRemarkTemplate(_setting, Enums.TransactionType.Quotation, Enums.FinanceType.OutFlow),
      deposit: GetSettingRemarkTemplate(_setting, Enums.TransactionType.Deposit, Enums.FinanceType.OutFlow),
      goodsReceipt: GetSettingRemarkTemplate(_setting, Enums.TransactionType.GoodsReceipt, Enums.FinanceType.OutFlow),
      invoiceReceipt: GetSettingRemarkTemplate(
        _setting,
        Enums.TransactionType.InvoiceReceipt,
        Enums.FinanceType.OutFlow
      ),
      expense: GetSettingRemarkTemplate(_setting, Enums.TransactionType.Invoice, Enums.FinanceType.OutFlow),
      receiveCN: GetSettingRemarkTemplate(_setting, Enums.TransactionType.CreditNote, Enums.FinanceType.OutFlow),
      billingNoteExpense: GetSettingRemarkTemplate(
        _setting,
        Enums.TransactionType.BillingNote,
        Enums.FinanceType.OutFlow
      ),
      fixedAsset: GetSettingRemarkTemplate(
        _setting,
        Enums.TransactionType.Invoice,
        Enums.FinanceType.OutFlow,
        Enums.TransactionItemType.Asset
      ),
    };
    return settingRemarkExpense;
  },
  ConvertToInputSettingRemark(_settingRemarkRevenue, _settingRemarkExpense) {
    let settingTransactionRemarkList = [];

    for (const [key, value] of Object.entries(_settingRemarkRevenue)) {
      let settingTransactionRemark = {
        transactionType: value.transactionType,
        financeType: value.financeType,
        transactionItemType: value.transactionItemType,
        remark: value.value,
        validateError: value.validateError,
      };
      settingTransactionRemarkList.push(settingTransactionRemark);
    }

    for (const [key, value] of Object.entries(_settingRemarkExpense)) {
      let settingTransactionRemark = {
        transactionType: value.transactionType,
        financeType: value.financeType,
        transactionItemType: value.transactionItemType,
        remark: value.value,
        validateError: value.validateError,
      };
      settingTransactionRemarkList.push(settingTransactionRemark);
    }

    return settingTransactionRemarkList;
  },
  GetSettingCompanyData(_setting) {
    let settingCompanyData = {
      verificationStatus: _setting.verificationStatus,
      merchantTaxId: _setting.merchantTaxId ? _setting.merchantTaxId : "",
      merchantBranchCode: _setting.merchantBranchCode ? _setting.merchantBranchCode : "",
      merchantType: _setting.merchantType,
      merchantName: {
        value: _setting.merchantName ? _setting.merchantName : "",
        validateError: false,
      },
      description: {
        value: _setting.description ? _setting.description : "",
        validateError: false,
      },
      registeredDate: _setting.registeredDate,
      vatRegistrationDate: null,
      isVat: _setting.isVat,
    };
    if (settingCompanyData.isVat) {
      settingCompanyData.vatRegistrationDate = _setting.vatRegistrationDate ? _setting.vatRegistrationDate : null;
    }
    return settingCompanyData;
  },
  GetSettingCompanyContact(_setting) {
    let settingCompanyContact = {
      phone: {
        value: _setting.phone ? _setting.phone : "",
        validateError: false,
      },
      email: {
        value: _setting.email ? _setting.email : "",
        validateError: false,
      },
      alternativeEmail: {
        value: _setting.alternativeEmail ? DecompressZlipData(_setting.alternativeEmail) : "",
        validateError: false,
      },
      lineId: {
        value: _setting.lineId ? _setting.lineId : "",
        validateError: false,
      },
      fax: {
        value: _setting.fax ? _setting.fax : "",
        validateError: false,
      },
      website: {
        value: _setting.website ? _setting.website : "",
        validateError: false,
      },
    };
    return settingCompanyContact;
  },
  GetSettingCompanyAddress(_setting) {
    let settingCompanyAddress = {
      building: {
        value: _setting.building ? _setting.building : "",
        validateError: false,
      },
      roomNo: {
        value: _setting.roomNo ? _setting.roomNo : "",
        validateError: false,
      },
      floorNo: {
        value: _setting.floorNo ? _setting.floorNo : "",
        validateError: false,
      },
      homeGroup: {
        value: _setting.homeGroup ? _setting.homeGroup : "",
        validateError: false,
      },
      homeno: {
        value: _setting.homeno ? _setting.homeno : "",
        validateError: false,
      },
      no: {
        value: _setting.no ? _setting.no : "",
        validateError: false,
      },
      soi: {
        value: _setting.soi ? _setting.soi : "",
        validateError: false,
      },
      road: {
        value: _setting.road ? _setting.road : "",
        validateError: false,
      },
      country: _setting.country ? _setting.country : "",
      district1: {
        value: _setting.district1 ? _setting.district1 : "",
        validateError: false,
      },
      district2: {
        value: _setting.district2 ? _setting.district2 : "",
        validateError: false,
      },
      province: {
        value: _setting.province ? _setting.province : "",
        validateError: false,
      },
      postCode: {
        value: _setting.postCode ? _setting.postCode : "",
        validateError: false,
      },
      sendBuilding: {
        value: _setting.sendBuilding ? _setting.sendBuilding : "",
        validateError: false,
      },
      sendRoomNo: {
        value: _setting.sendRoomNo ? _setting.sendRoomNo : "",
        validateError: false,
      },
      sendFloorNo: {
        value: _setting.sendFloorNo ? _setting.sendFloorNo : "",
        validateError: false,
      },
      sendHomeGroup: {
        value: _setting.sendHomeGroup ? _setting.sendHomeGroup : "",
        validateError: false,
      },
      sendHomeNo: {
        value: _setting.sendHomeNo ? _setting.sendHomeNo : "",
        validateError: false,
      },
      sendNo: {
        value: _setting.sendNo ? _setting.sendNo : "",
        validateError: false,
      },
      sendSoi: {
        value: _setting.sendSoi ? _setting.sendSoi : "",
        validateError: false,
      },
      sendRoad: {
        value: _setting.sendRoad ? _setting.sendRoad : "",
        validateError: false,
      },
      sendCountry: _setting.sendCountry ? _setting.sendCountry : "",
      sendDistrict1: {
        value: _setting.sendDistrict1 ? _setting.sendDistrict1 : "",
        validateError: false,
      },
      sendDistrict2: {
        value: _setting.sendDistrict2 ? _setting.sendDistrict2 : "",
        validateError: false,
      },
      sendProvince: {
        value: _setting.sendProvince ? _setting.sendProvince : "",
        validateError: false,
      },
      sendPostCode: {
        value: _setting.sendPostcode ? _setting.sendPostcode : "",
        validateError: false,
      },
    };
    return settingCompanyAddress;
  },
  GetSettingCompanyAddressList(settingCompanyAddressList) {
    const settingCompanyAddresses = [];
    for (let settingCompanyAddress of settingCompanyAddressList) {
      settingCompanyAddresses.push({
        id: settingCompanyAddress.id ? settingCompanyAddress.id : "",
        language: settingCompanyAddress.language,
        name: {
          value: settingCompanyAddress.name ? settingCompanyAddress.name : "",
          validateError: false,
        },
        addressName: {
          value: settingCompanyAddress.addressName ? settingCompanyAddress.addressName : "",
          validateError: false,
        },
        building: {
          value: settingCompanyAddress.building ? settingCompanyAddress.building : "",
          validateError: false,
        },
        roomNo: {
          value: settingCompanyAddress.roomNo ? settingCompanyAddress.roomNo : "",
          validateError: false,
        },
        floorNo: {
          value: settingCompanyAddress.floorNo ? settingCompanyAddress.floorNo : "",
          validateError: false,
        },
        homeGroup: {
          value: settingCompanyAddress.homeGroup ? settingCompanyAddress.homeGroup : "",
          validateError: false,
        },
        homeNo: {
          value: settingCompanyAddress.homeNo ? settingCompanyAddress.homeNo : "",
          validateError: false,
        },
        no: {
          value: settingCompanyAddress.no ? settingCompanyAddress.no : "",
          validateError: false,
        },
        soi: {
          value: settingCompanyAddress.soi ? settingCompanyAddress.soi : "",
          validateError: false,
        },
        road: {
          value: settingCompanyAddress.road ? settingCompanyAddress.road : "",
          validateError: false,
        },
        country: settingCompanyAddress.country ? settingCompanyAddress.country : "",
        district1: {
          value: settingCompanyAddress.district1 ? settingCompanyAddress.district1 : "",
          validateError: false,
        },
        district2: {
          value: settingCompanyAddress.district2 ? settingCompanyAddress.district2 : "",
          validateError: false,
        },
        province: {
          value: settingCompanyAddress.province ? settingCompanyAddress.province : "",
          validateError: false,
        },
        postCode: {
          value: settingCompanyAddress.postCode ? settingCompanyAddress.postCode : "",
          validateError: false,
        },

        address:
          (settingCompanyAddress.building
            ? i18n.t("Input_Building") + " " + settingCompanyAddress.building + " "
            : "") +
          (settingCompanyAddress.roomNo ? i18n.t("Room_No") + " " + settingCompanyAddress.roomNo + " " : "") +
          (settingCompanyAddress.floorNo ? i18n.t("Floor_No") + " " + settingCompanyAddress.floorNo + " " : "") +
          (settingCompanyAddress.homeGroup ? i18n.t("village") + " " + settingCompanyAddress.homeGroup + " " : "") +
          (settingCompanyAddress.no ? i18n.t("house_number") + " " + settingCompanyAddress.no + " " : "") +
          (settingCompanyAddress.homeNo ? i18n.t("village_No") + " " + settingCompanyAddress.homeNo + " " : "") +
          (settingCompanyAddress.soi ? i18n.t("Alley_Lane") + " " + settingCompanyAddress.soi + " " : "") +
          (settingCompanyAddress.road ? i18n.t("Road") + " " + settingCompanyAddress.road + " " : ""),
      });
    }
    return settingCompanyAddresses;
  },
  GetSettingMerchantAddressListDefault() {
    return GetSettingMerchantAddressListDefault();
  },
  GetSettingDueDateRevenue(_setting) {
    let settingDueDateRevenue = {
      quotation: GetSettingDueDate(_setting, Enums.TransactionType.Quotation, Enums.FinanceType.InFlow),
      invoice: GetSettingDueDate(_setting, Enums.TransactionType.Invoice, Enums.FinanceType.InFlow),
      billingNote: GetSettingDueDate(_setting, Enums.TransactionType.BillingNote, Enums.FinanceType.InFlow),
      deposit: GetSettingDueDate(_setting, Enums.TransactionType.Deposit, Enums.FinanceType.InFlow),
    };
    return settingDueDateRevenue;
  },
  GetSettingDueDateExpense(_setting) {
    let settingDueDateRevenue = {
      purchaseRequisition: GetSettingDueDate(
        _setting,
        Enums.TransactionType.PurchaseRequisition,
        Enums.FinanceType.OutFlow
      ),
      deposit: GetSettingDueDate(_setting, Enums.TransactionType.Deposit, Enums.FinanceType.OutFlow),
      expense: GetSettingDueDate(_setting, Enums.TransactionType.Invoice, Enums.FinanceType.OutFlow),
      billingNoteExpense: GetSettingDueDate(_setting, Enums.TransactionType.BillingNote, Enums.FinanceType.OutFlow),
      fixedAsset: GetSettingDueDate(
        _setting,
        Enums.TransactionType.Invoice,
        Enums.FinanceType.OutFlow,
        Enums.TransactionItemType.Asset
      ),
    };
    return settingDueDateRevenue;
  },
  ConvertToInputSettingDueDate(_settingDueDateRevenue, _settingDueDateExpense) {
    let settingTransactionDueDateList = [];

    for (const [key, value] of Object.entries(_settingDueDateRevenue)) {
      let settingTransactionDueDate = {
        transactionType: value.transactionType,
        financeType: value.financeType,
        transactionItemType: value.transactionItemType,
        settingDueDateType: value.settingDueDateType.value.value,
        day: value.day.value,
      };
      settingTransactionDueDateList.push(settingTransactionDueDate);
    }

    for (const [key, value] of Object.entries(_settingDueDateExpense)) {
      let settingTransactionDueDate = {
        transactionType: value.transactionType,
        financeType: value.financeType,
        transactionItemType: value.transactionItemType,
        settingDueDateType: value.settingDueDateType.value.value,
        day: value.day.value,
      };
      settingTransactionDueDateList.push(settingTransactionDueDate);
    }
    return settingTransactionDueDateList;
  },
  GetAddUserTemplate() {
    let addUserTemplate = {
      email: { value: "", validateError: "" },
      settingUserRole: GetSettingUserRoleTemplate(),
    };

    return addUserTemplate;
  },
  ConvertToInputAddNewUser(addUserTemplate, isUpdateOnboarding) {
    let inputAddNewUser = {
      userName: addUserTemplate.email.value,
      manageUser: addUserTemplate.settingUserRole.isManageUser,
      manageFinance: addUserTemplate.settingUserRole.isManageFinance,
      isUsePayroll: addUserTemplate.settingUserRole.isUsePayroll,
      isUsePeakBoard: addUserTemplate.settingUserRole.isUsePeakBoard,
      isSeeSelfDocuments: addUserTemplate.settingUserRole.isSeeSelfDocuments,
      userRoleModel: ConverToUserRoleModel(addUserTemplate.settingUserRole),
      isUpdateOnboarding: isUpdateOnboarding,
    };
    return inputAddNewUser;
  },
  GetUserDetailTemplate(_userDetail) {
    let userDetailTemplate = {
      email: _userDetail.email,
      firstName: _userDetail.firstName,
      lastName: _userDetail.lastName,
      settingUserRole: GetSettingUserRoleTemplate(_userDetail),
    };
    return userDetailTemplate;
  },
  ConvertToInputUpdateUser(userDetailTemplate, userId) {
    let inputUpdateUser = {
      userId: userId,
      userRole: ConverToUserRoleModel(userDetailTemplate.settingUserRole),
    };

    return inputUpdateUser;
  },
  ValidateInputSettingNumber(_settingTransactionNumberList, _settingNumberRevenue, _settingNumberExpense) {
    let validateInput = true;
    let duplicateList = [];

    const settingTransactionNumberList = [];
    for (let settingTransactionNumber of _settingTransactionNumberList.settingTransactionNumberList) {
      if (
        settingTransactionNumber.headerTransactionType == Enums.HeaderTransactionType.InvoiceSalesTaxReceipt &&
        settingTransactionNumber.financeType == Enums.FinanceType.InFlow
      ) {
        if (_settingTransactionNumberList.isSeparateRunningInvoiceTaxInvoiceNumber) {
          settingTransactionNumberList.push(settingTransactionNumber);
        }
      } else if (
        settingTransactionNumber.headerTransactionType == Enums.HeaderTransactionType.ReceiptSalesTaxReceipt &&
        settingTransactionNumber.financeType == Enums.FinanceType.InFlow
      ) {
        if (_settingTransactionNumberList.isSeparateRunningReceiptTaxInvoiceNumber) {
          settingTransactionNumberList.push(settingTransactionNumber);
        }
      } else if (
        settingTransactionNumber.headerTransactionType == Enums.HeaderTransactionType.CreditNoteTaxReceipt &&
        settingTransactionNumber.financeType == Enums.FinanceType.InFlow
      ) {
        if (_settingTransactionNumberList.isSeparateRunningCreditNoteTaxInvoiceNumber) {
          settingTransactionNumberList.push(settingTransactionNumber);
        }
      } else if (
        settingTransactionNumber.headerTransactionType == Enums.HeaderTransactionType.DebitNote &&
        settingTransactionNumber.financeType == Enums.FinanceType.InFlow
      ) {
        if (_settingTransactionNumberList.isSeparateRunningDebitNoteTaxInvoiceNumber) {
          settingTransactionNumberList.push(settingTransactionNumber);
        }
      } else if (
        settingTransactionNumber.headerTransactionType == Enums.HeaderTransactionType.Deposit &&
        settingTransactionNumber.financeType == Enums.FinanceType.InFlow
      ) {
        if (_settingTransactionNumberList.isSeparateRunningDepositTaxInvoiceNumber) {
          settingTransactionNumberList.push(settingTransactionNumber);
        }
      } else if (
        settingTransactionNumber.headerTransactionType == Enums.HeaderTransactionType.Quotation &&
        settingTransactionNumber.financeType == Enums.FinanceType.OutFlow
      ) {
        if (_settingTransactionNumberList.isSeparateRunningPuchaseOrderAssetNumber) {
          settingTransactionNumberList.push(settingTransactionNumber);
        }
      } else {
        settingTransactionNumberList.push(settingTransactionNumber);
      }
    }

    settingTransactionNumberList.forEach((item1, index1) => {
      settingTransactionNumberList.forEach((item2, index2) => {
        if (index1 !== index2) {
          if (item1.indexString === item2.indexString) {
            duplicateList.push(item1);
          }
        }
      });
    });

    if (duplicateList.length > 0) {
      validateInput = false;
      SetValidateError(duplicateList, _settingNumberRevenue, _settingNumberExpense, _settingTransactionNumberList);
    }

    return validateInput;
  },
  ValidateUpdateMerchantDtail(
    _settingCompanyData,
    _settingCompanyContact,
    _settingCompanyAdditionalAddressList,
    _registeredAddressEng,
    _registeredAddress,
    _deliveryAddress
  ) {
    let validateModel = {
      isError: false,
      alertMessage: "AlertNoti_Create_Input_Error",
    };

    if (_settingCompanyData.merchantName.value == "") {
      _settingCompanyData.merchantName.validateError = true;
    }
    if (!_settingCompanyData.vatRegistrationDate) {
      _settingCompanyData.vatRegistrationDate = "";
    }
    if (!_settingCompanyData.registeredDate) {
      _settingCompanyData.registeredDate = "";
    }
    if (_settingCompanyContact.email.value != "" && !_settingCompanyContact.email.value.ValidateEmail()) {
      _settingCompanyContact.email.validateError = true;
      validateModel.alertMessage = "Alert_Email_Merchantsetting";
    }

    validateModel.isError = _settingCompanyData.merchantType == 0 ? true : validateModel.isError;
    validateModel.isError = CheckErrorUpdateMerchantDtail(_settingCompanyData, validateModel.isError);
    validateModel.isError = CheckErrorUpdateMerchantDtail(_registeredAddress, validateModel.isError);
    validateModel.isError = CheckErrorUpdateMerchantDtail(_deliveryAddress, validateModel.isError);
    validateModel.isError = CheckErrorUpdateMerchantDtail(_settingCompanyContact, validateModel.isError);
    validateModel.isError = CheckErrorUpdateMerchantDtail(_registeredAddressEng, validateModel.isError);
    if (_settingCompanyAdditionalAddressList.length > 0) {
      for (let item of _settingCompanyAdditionalAddressList) {
        if (item.addressName.value == "") {
          item.addressName.validateError = true;
        }
        if (item.name.value == "") {
          item.name.validateError = true;
        }
        if (item.no.value == "") {
          item.no.validateError = true;
        }
        if (item.country == "" || (item.country.code == "" && item.country.name == "")) {
          item.country = {
            validateError: true,
          };
        }
        if (item.district1.value == "") {
          item.district1.validateError = true;
        }
        if (item.district2.value == "") {
          item.district2.validateError = true;
        }
        if (item.province.value == "") {
          item.province.validateError = true;
        }
        if (item.postCode.value == "") {
          item.postCode.validateError = true;
        }
        validateModel.isError = CheckErrorUpdateMerchantDtail(item, validateModel.isError);
      }
    }
    return validateModel;
  },
  ConvertToInputgetOnlineViewPublicFormatSetting(
    isShowSignatureOnPublicLink,
    isShowStampOnPublicLink,
    isUsePassCodeOnPublicLink
  ) {
    let getOnlineViewPublicFormatSetting = {
      isShowSignatureOnPublicLink: _getOnlineViewPublicFormatSetting.isShowSignatureOnPublicLink,
      isShowStampOnPublicLink: _getOnlineViewPublicFormatSetting.isShowStampOnPublicLink,
      isUsePassCodeOnPublicLink: _getOnlineViewPublicFormatSetting.isUsePassCodeOnPublicLink,
    };
    return getOnlineViewPublicFormatSetting;
  },
  ValidateUpdateINetAuthenticationData(iNetAuthentication) {
    let isError = false;
    if (
      iNetAuthentication.sellerTaxId.value == "" ||
      iNetAuthentication.sellerBranchId.value == "" ||
      iNetAuthentication.apiKey.value == "" ||
      iNetAuthentication.userCode.value == "" ||
      iNetAuthentication.accessKey.value == "" ||
      iNetAuthentication.sellerTaxId.validateError ||
      iNetAuthentication.sellerBranchId.validateError ||
      iNetAuthentication.apiKey.validateError ||
      iNetAuthentication.userCode.validateError ||
      iNetAuthentication.accessKey.validateError
    ) {
      isError = true;
    }
    return isError;
  },
  GetMerchantAddress(addressDetail) {
    let address =
      (addressDetail.building ? i18n.t("Input_Building") + " " + addressDetail.building + " " : "") +
      (addressDetail.roomNo ? i18n.t("Room_No") + " " + addressDetail.roomNo + " " : "") +
      (addressDetail.floorNo ? i18n.t("Floor_No") + " " + addressDetail.floorNo + " " : "") +
      (addressDetail.homeGroup ? i18n.t("village") + " " + addressDetail.homeGroup + " " : "") +
      (addressDetail.no ? i18n.t("house_number") + " " + addressDetail.no + " " : "") +
      (addressDetail.homeno ? i18n.t("village_No") + " " + addressDetail.homeno + " " : "") +
      (addressDetail.soi ? i18n.t("Alley_Lane") + " " + addressDetail.soi + " " : "") +
      (addressDetail.road ? i18n.t("Road") + " " + addressDetail.road : "");

    const districtPrefix = addressDetail.province
      ? addressDetail.province.startsWith("กรุงเทพ")
        ? i18n.t("เขต")
        : i18n.t("อำเภอ")
      : "";
    const subDistrictPrefix = addressDetail.province
      ? addressDetail.province.startsWith("กรุงเทพ")
        ? i18n.t("แขวง")
        : i18n.t("ตำบล")
      : "";
    const provincePrefix = addressDetail.province
      ? addressDetail.province.startsWith("กรุงเทพ")
        ? ""
        : i18n.t("จังหวัด")
      : "";

    return `${address} ${subDistrictPrefix}${addressDetail.district1} ${districtPrefix}${addressDetail.district2} ${provincePrefix}${addressDetail.province} ${addressDetail.postCode}`;
  },
  GetConvertToOtherAddressOfPackage(otherAddress) {
    let address = {
      homeGroup: otherAddress.homeGroup,
      building: otherAddress.building,
      roomNo: otherAddress.roomNo,
      floorNo: otherAddress.floorNo,
      homeNo: otherAddress.homeNo,
      no: otherAddress.no,
      soi: otherAddress.soi,
      road: otherAddress.road,
      district1: otherAddress.subDistrict,
      district2: otherAddress.district,
      province: otherAddress.province,
      country: otherAddress.country,
      postCode: otherAddress.postCode,
    };
    return address;
  },
  GetConnectToBentoWebTemplate() {
    const connectToBentoWebTemplate = {
      bentoUserName: {
        value: "",
        validateError: false,
      },
      bentoPassWord: {
        value: "",
        validateError: false,
      },
      clientSecretCode: {
        value: "",
        validateError: false,
      },
      clientId: {
        value: "",
        validateError: false,
      },
      storeId: {
        value: "",
        validateError: false,
      },
    };
    return connectToBentoWebTemplate;
  },
  ConvertToConnectToBentoWeb(bentoWebTemplate) {
    const connectToBentoWeb = {
      username: bentoWebTemplate.bentoUserName.value,
      password: bentoWebTemplate.bentoPassWord.value,
      secretKey: bentoWebTemplate.clientSecretCode.value,
      clientId: bentoWebTemplate.clientId.value.ToNumber(),
      storeId: bentoWebTemplate.storeId.value.ToNumber(),
    };
    return connectToBentoWeb;
  },
  GetConnectPartnerAppType(ApiPartnerDetail) {
    switch (ApiPartnerDetail) {
      case Enums.ApiPartnerDetail.Empeo:
      case Enums.ApiPartnerDetail.Venio:
        return Enums.ApiPartner.Gofive;
        break;
      case Enums.ApiPartnerDetail.Jubili:
        return Enums.ApiPartner.Jubili;
        break;
      case Enums.ApiPartnerDetail.BoxMe:
        return Enums.ApiPartner.BoxMe;
        break;
      case Enums.ApiPartnerDetail.UCommerce:
        return Enums.ApiPartner.UCommerce;
        break;
      case Enums.ApiPartnerDetail.HumanSoft:
        return Enums.ApiPartner.HumanSoft;
        break;
      case Enums.ApiPartnerDetail.Shipnity:
        return Enums.ApiPartner.Shipnity;
        break;
      case Enums.ApiPartnerDetail.XSelly:
        return Enums.ApiPartner.XSelly;
        break;
      case Enums.ApiPartnerDetail.JSTERP:
        return Enums.ApiPartner.JSTERP;
        break;
      case Enums.ApiPartnerDetail.MCS:
        return Enums.ApiPartner.MCS;
        break;
      case Enums.ApiPartnerDetail.SeniorSoft:
        return Enums.ApiPartner.SeniorSoft;
        break;
      case Enums.ApiPartnerDetail.Page365:
        return Enums.ApiPartner.None;
        break;
      default:
        return ApiPartnerDetail;
        break;
    }
  },
  GetConnectPartnerAppTypeName(ApiPartner) {
    switch (ApiPartner) {
      case Enums.ApiPartner.KetshopWeb:
        return "KetshopWeb";
      case Enums.ApiPartner.ZORT:
        return "ZORT";
      case Enums.ApiPartner.xCommerce:
        return "xCommerce";
      case Enums.ApiPartner.Gofive:
        return "Gofive";
      case Enums.ApiPartner.BoxMe:
        return "BoxMe";
      case Enums.ApiPartner.Leceipt:
        return "Leceipt";
      case Enums.ApiPartner.UCommerce:
        return "UCommerce";
      case Enums.ApiPartner.HumanSoft:
        return "HumanSoft";
      case Enums.ApiPartner.Shipnity:
        return "Shipnity";
      case Enums.ApiPartner.XSelly:
        return "XSelly";
      case Enums.ApiPartner.JSTERP:
        return "JSTERP";
      case Enums.ApiPartner.MCS:
        return "Miracle Clinic System";
      case Enums.ApiPartner.SeniorSoft:
        return "SeniorSoft";
      case Enums.ApiPartner.Jubili:
        return "Jubili";
      case Enums.ApiPartner.None:
        return "";
    }
  },
  ConvertFetchDataTypeToTitle(fetchDataType) {
    switch (fetchDataType) {
      case Enums.FetchDataType.ByPeriod:
        return "Fetch_Order_By_Period";
      case Enums.FetchDataType.ByOrderCode:
        return "Fetch_Order_By_Code";
      case Enums.FetchDataType.ByMonth:
        return "Fetch_Order_By_Month";
    }
  },
  ConvertFetchDataTypeToTooltips(fetchDataType) {
    switch (fetchDataType) {
      case Enums.FetchDataType.ByPeriod:
        return "Fetch_Order_By_Period_Tooltip";
      case Enums.FetchDataType.ByOrderCode:
        return "Fetch_Order_By_Code_Tooltip";
    }
  },
};
